const isInsideDatepicker = (target) => !!target.closest('.p-datepicker, .p-calendar');

export default function installDatepickerDismissGuard() {
  let dismissing = false;

  document.addEventListener(
    'mousedown',
    (event) => {
      const overlayOpen = document.querySelector('.p-datepicker:not(.p-datepicker-inline)');
      dismissing = !!overlayOpen && !isInsideDatepicker(event.target);
    },
    true,
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!dismissing) return;
      dismissing = false;
      event.stopPropagation();
      event.preventDefault();
    },
    true,
  );
}
